<template>
  <div class="landing">
    <HeroSingle v-if="content.hero" :content="content.hero"></HeroSingle>

    <div
      v-for="(cpt, index) in content.flexibleContent"
      :key="`fl-${index}`"
      :class="`cpt-` + cpt.component"
    >
      <component
        :is="components[cpt.component]"
        v-if="cpt.component && components[cpt.component]"
        :content="cpt.content"
        class="wrapper"
      />
      <pre v-else>coming soon: {{ cpt.component }} - {{ cpt.content }}</pre>
    </div>
  </div>
</template>

<script setup lang="ts">
import DuoGallery from '@/components/duo/Gallery.vue'
import DuoText from '@/components/duo/Text.vue'
import FlexibleAdvantages from '@/components/flexible/Advantages.vue'
import FlexibleAppointmentCta from '@/components/flexible/AppointmentCta.vue'
import FlexibleCategories from '@/components/flexible/Categories.vue'
import FlexibleFaq from '@/components/flexible/Faq.vue'
import FlexibleKeypoints from '@/components/flexible/Keypoints.vue'
import FlexibleSubCategories from '@/components/flexible/SubCategories.vue'
import FlexibleText from '@/components/flexible/Text.vue'
import FlexibleTitle from '@/components/flexible/Title.vue'
import FlexibleVideo from '@/components/flexible/Video.vue'
import BigCta from '@/components/global/BigCta.vue'
import FullwidthPicture from '@/components/global/FullwidthPicture.vue'
import Loop from '@/components/global/VideoLoop.vue'
import HeroSingle from '@/components/hero/Single.vue'

import type { Component } from 'vue'

// Props
defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const components: Record<string, Component> = {
  wysiwyg: FlexibleText,
  video: FlexibleVideo,
  highlightedSubcategories: FlexibleSubCategories,
  appointmentCta: FlexibleAppointmentCta,
  faq: FlexibleFaq,
  title: FlexibleTitle,
  advantages: FlexibleAdvantages,
  loop: Loop,
  duoGallery: DuoGallery,
  duoText: DuoText,
  fullwidthPicture: FullwidthPicture,
  keypoints: FlexibleKeypoints,
  bigCta: BigCta,
  highlightedCategories: FlexibleCategories,
}
</script>

<style lang="scss" scoped>
.landing {
  // prettier-ignore
  @include fluid(padding-top, (xxs: 6rem, xxl: 12rem));

  :deep(.hero-single__picture) {
    @include mq($until: s) {
      aspect-ratio: 1;
    }
  }

  :deep(.appointment__cta) {
    display: none;
  }
}

.wrapper {
  :deep(.carousel__controls) {
    display: none;
  }

  :deep(.carousel__scroller) {
    @include mq(m) {
      cursor: default;
    }
  }

  :deep(.carousel__item) {
    width: calc(col(8) - 0.6rem);
  }
}
</style>
